import { render } from "./App.vue?vue&type=template&id=36446d84"
const script = {}

import "./App.vue?vue&type=style&index=0&id=36446d84&lang=scss"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__